import React from 'react';
import Dussehra2023 from 'views/Dussehra2023'

const SchoolProgrampage = () => {
  return <Dussehra2023 />;
};

export default SchoolProgrampage;